// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asyncapi {\n    color: #000;\n    font-family: 'Ubuntu Mono', monospace;\n    height: calc(100vh - 68px);\n}\n\n.asyncapi__anchor-icon {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
